import { OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "./auth.service";
import { TokenService } from "./token.service";
import { MessageService } from "primeng/api";
import { ResponseData } from "../../helpers/response";
import { IAuthUser } from "./interfaces";
import { tokenNotExpired } from "./helper";
import { IEvent } from "../../interfaces/event.interface";

export class LoginManager<T extends IAuthUser> implements OnInit, IEvent {
  returnUrl: string;

  constructor(
    public service: AuthService<T>,
    public router: Router,
    public route: ActivatedRoute,
    public tokenService: TokenService,
    public toastr?: MessageService
  ) {}

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";

    if (tokenNotExpired()) {
      this.router.navigate([this.returnUrl]);
    }
  }

  login() {
    this.service.loading = true;

    this.service.login(
      response => {
        this.service.loading = false;

        if (response.DataSource.Token) {
          this.tokenService.setToken(
            response.DataSource.Token,
            response.DataSource.RefreshToken
          );

          this.service.validateChangePassword();
          this.onSuccess("onLogin", response);
        } else {
          const error = "Token no encontrado";

          if (this.toastr) {
            this.toastr.add({
              severity: "error",
              summary: "Inicio de sesiÃ³n",
              detail: error
            });
          }

          return;
        }
      },
      error => this.onError("onError", error)
    );
  }

  onSuccess(source: string, response: ResponseData) {
    this.router.navigate([this.returnUrl]);
  }

  onError(source: string, error: string | ResponseData) {
    this.service.loading = false;
  }
}
